import React, { FunctionComponent } from 'react';
import { Segment } from 'semantic-ui-react';
import { Review } from '../types/review.type';
import { ProViewZones } from './ProViewZone';
import {
  hasSeveralCompanyPresentations,
  ReviewPresentationsButton,
} from './ReviewPresentationsButton';

type ReviewPresentationsLineProps = {
  review: Review;
  onReviewChange: () => void;
  /** The presentation of the page, listed first */
  presentationId?: number;
};

/**
 * Where the review is visible: its presentations with their views, and the button to change
 * them. Shown for every review of a company with several presentations, even when it is visible
 * on one only, so that the team sees where it is displayed and can share it from there.
 */
export const ReviewPresentationsLine: FunctionComponent<
  ReviewPresentationsLineProps
> = ({ review, onReviewChange, presentationId }) => {
  if (!hasSeveralCompanyPresentations(review)) return null;

  const presentations = [...review.presentations]
    .map(({ presentation }) => presentation)
    .sort(
      (a, b) =>
        Number(b.id === presentationId) - Number(a.id === presentationId),
    );

  return (
    <Segment>
      <div style={{ display: 'flex', alignItems: 'baseline', gap: '12px' }}>
        <span style={{ color: '#767676', whiteSpace: 'nowrap' }}>
          Visible sur :
        </span>
        <div style={{ display: 'grid', gap: '4px' }}>
          {presentations.map((presentation, index) => (
            <div key={presentation.id}>
              {presentation.mainTradeNames || presentation.name}{' '}
              <ProViewZones proViews={presentation.proViews} />
              {index === presentations.length - 1 ? (
                // Negative margins: the button does not make its line taller than the others
                <span
                  style={{
                    display: 'inline-block',
                    margin: '-5px 0 -5px 12px',
                    verticalAlign: 'middle',
                  }}
                >
                  <ReviewPresentationsButton
                    review={review}
                    onReviewChange={onReviewChange}
                    variant="text"
                  />
                </span>
              ) : null}
            </div>
          ))}
        </div>
      </div>
    </Segment>
  );
};
